{
  "title": "Gravity Sinkhole",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "4th-level evocation (dunamancy:graviturgy)",
  "level": 4,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (a black marble)",
  "duration": "Instantaneous",
  "description": [
    "A 20-foot-radius sphere of crushing force forms at a point you can see within range and tugs at the creatures there. Each creature in the sphere must make a Constitution saving throw. On a failed save, the creature takes 5d10 force damage, and is pulled in a straight line toward the center of the sphere, ending in an unoccupied space as close to the center as possible (even if that space is in the air). On a successful save, the creature takes half as much damage and isn't pulled.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, the damage increases by 1d10 for each slot level above 4th."
  ],
  "spellLists": ["eldritch-knight", "wizard"]
}
